import { render } from "./PopupAd.vue?vue&type=template&id=71002936&scoped=true"
import script from "./PopupAd.vue?vue&type=script&lang=js"
export * from "./PopupAd.vue?vue&type=script&lang=js"

import "./PopupAd.vue?vue&type=style&index=0&id=71002936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71002936"]])

export default __exports__